import PropTypes from 'prop-types';
import React, { memo } from 'react';

import GoogleOAuthButton from 'components/common/google-oauth-button/google-oauth-button';
import LinkedInOAuthButton from 'components/common/linkedin-oauth-button/linkedin-oauth-button';

import './auth-social-buttons.scss';

const AuthSocialButtons = memo((props) => {
  const { googleButtonLabel, linkedinButtonLabel, handleGoogleSign, handleLinkedinSign } = props;

  return (
    <div className='auth-social-buttons'>
      <GoogleOAuthButton
        buttonLabel={ googleButtonLabel }
        className='auth-social-buttons__button'
        handleGoogleSign={ handleGoogleSign }
      />
      <LinkedInOAuthButton
        buttonLabel={ linkedinButtonLabel }
        className='auth-social-buttons__button'
        handleLinkedinSign={ handleLinkedinSign }
      />
    </div>
  );
});

AuthSocialButtons.displayName = 'AuthSocialButtons';

AuthSocialButtons.propTypes = {
  // The Google button label
  googleButtonLabel: PropTypes.string.isRequired,
  // The function (accessToken, tokenType) => void to handle the google auth sign
  handleGoogleSign: PropTypes.func.isRequired,
  // The function (authorizationCode) => void to handle the linkedin auth sign
  handleLinkedinSign: PropTypes.func.isRequired,
  // The LinkedIn button label
  linkedinButtonLabel: PropTypes.string.isRequired,
};

AuthSocialButtons.defaultProps = {};

export default AuthSocialButtons;
